"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Card = _interopRequireDefault(require("@mui/material/Card"));

var _CardActions = _interopRequireDefault(require("@mui/material/CardActions"));

var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));

var _CardHeader = _interopRequireDefault(require("@mui/material/CardHeader"));

var _utilities = require("../../utilities");

// `Card` is the only component in this repo at the moment that produces
// `&:first-child` warnings which is why we're calling this here specifically.
(0, _utilities.disableEmotionWarnings)();
var Card = Object.assign(_Card.default, {
  Actions: _CardActions.default,
  Content: _CardContent.default,
  Header: _CardHeader.default
});
var _default = Card;
exports.default = _default;